export default "__VITE_ASSET__4ww4yfP7__"